module.exports = __webpack_public_path__ + "static/media/IRN_Done.7b8418d9.svg";